import React from 'react';
import {settingsText} from '../../settingsText';
import './styles.css';
import OrgDataForm from '../../../../forms/OrgDataForm';
import {OrganizationSettings} from '../../../../data/models/Oganization/Organization';
import ErrorBox from '../../../../uiToolkit/ErrorBox';

interface Props {
  onEdit: (organization: OrganizationSettings, image?: File) => void;
  organization: OrganizationSettings;
  isLoading: boolean;
  errors: string[];
  onCancel: () => void;
  clearErrors: () => void;
  showColors: boolean;
}

const GeneralSettingsUI = React.memo(
  ({
    onEdit,
    organization,
    isLoading,
    errors,
    onCancel,
    clearErrors,
    showColors,
  }: Props) => {
    const onSubmit = (
      name: string,
      primaryColor: string,
      secondaryColor: string,
      type: number,
      llmProvider?: string,
      image?: File,
    ) => {
      const updatedOrganization = {
        ...organization,
        name,
        primaryColor,
        secondaryColor,
        type,
        llmProvider,
      };
      onEdit(updatedOrganization, image);
    };

    return (
      <div className="GeneralSettingsContainer">
        <ErrorBox
          errorCodes={errors}
          className="ErrorBox"
          clearErrors={clearErrors}
        />
        <OrgDataForm
          onSubmit={onSubmit}
          onCancel={onCancel}
          submitText={settingsText.save}
          isLoading={isLoading}
          organization={organization}
          skipColors={!showColors}
        />
      </div>
    );
  },
);

export default GeneralSettingsUI;
